import React, { ReactElement } from 'react';
import { WorkerChangeTabProps } from 'containers/entityChange/worker/types';

export function WorkerComments(props: WorkerChangeTabProps): ReactElement {
  const { loading, worker, onTabApiChange } = props; // eslint-disable-line unused-imports/no-unused-vars

  // get worker jobsites changes

  // React.useEffect(() => onTabApiChange({ refetchData: refetchWorkerData }), [refetchWorkerData]);

  return <div>Worker Comments Changes</div>;
}
